/**
 * Adissoo Yazıcı Köprüsü ile konuşma (20 Eki 2026).
 *
 * Tarayıcı ağdaki bir yazıcıya (IP:9100) kendisi bağlanamıyor; kasa
 * bilgisayarında arka planda çalışan küçük program (kioskSetup'taki kurulum
 * dosyası kuruyor) yalnız bu bilgisayardan, 127.0.0.1 üstünden istek kabul
 * ediyor ve gelen baytları yazıcıya iletiyor. Program yalnız adissoo.com'dan
 * gelen isteği ve yalnız yerel ağdaki adresleri kabul ediyor.
 */

export const BRIDGE_URL = 'http://127.0.0.1:17777'

const KEY = 'adissoo.networkPrint'

/**
 * Bu cihaz fişleri ağ yazıcılarına mı gönderiyor. Cihaz ayarı: yazıcı listesi
 * kurumun, ama basan bilgisayar bir tane; garsonun telefonu da aynı listeyi
 * görüyor ve basmamalı.
 */
export function getNetworkPrint(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on'
  } catch {
    return false
  }
}

export function setNetworkPrint(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off')
  } catch {
    // Gizli pencere: ayar bu oturumluk kalmıyor, zararı yok.
  }
}

async function call(path: string, init: RequestInit = {}, timeoutMs = 4000): Promise<Response> {
  const ctl = new AbortController()
  const t = window.setTimeout(() => ctl.abort(), timeoutMs)
  try {
    return await fetch(`${BRIDGE_URL}${path}`, { ...init, signal: ctl.signal })
  } finally {
    window.clearTimeout(t)
  }
}

/** Köprü bu bilgisayarda çalışıyor mu; sürümünü döner, yoksa null. */
export async function bridgeVersion(): Promise<string | null> {
  try {
    const r = await call('/durum', {}, 1500)
    if (!r.ok) return null
    const d = (await r.json()) as { ok?: boolean; surum?: string }
    return d.ok ? d.surum ?? '?' : null
  } catch {
    return null
  }
}

function toBase64(bytes: Uint8Array): string {
  let s = ''
  for (let i = 0; i < bytes.length; i += 0x8000) {
    s += String.fromCharCode(...bytes.subarray(i, i + 0x8000))
  }
  return btoa(s)
}

/** Baytları yazıcıya gönderir; ulaşamazsa okunur bir hata fırlatır. */
export async function sendToPrinter(host: string, port: number, bytes: Uint8Array): Promise<void> {
  let r: Response
  try {
    r = await call(
      '/yazdir',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ host, port, data: toBase64(bytes) }),
      },
      15000,
    )
  } catch {
    throw new Error('Yazıcı Köprüsü bu bilgisayarda çalışmıyor.')
  }
  const d = (await r.json().catch(() => ({}))) as { ok?: boolean; hata?: string }
  if (!r.ok || !d.ok) throw new Error(d.hata || 'Yazıcıya ulaşılamadı.')
}

/**
 * Yerel ağda 9100 portu açık cihazlar (fiş yazıcıları), köprünün taraması.
 * Köprü yoksa ya da eski sürümse null.
 */
export async function scanPrinters(): Promise<string[] | null> {
  try {
    const r = await call('/tara', {}, 8000)
    if (!r.ok) return null
    const d = (await r.json()) as { ok?: boolean; yazicilar?: string[] }
    return d.ok && Array.isArray(d.yazicilar) ? d.yazicilar : null
  } catch {
    return null
  }
}
